import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { FILTER_TYPE_META } from '../../../../constants/reviewEntriesFilterConfig'
import { ReviewEntriesFilterType } from '../../../../enums/reviewEntriesFilterType'
import type { ReviewEntriesFiltersState } from '../../../../types/reviewEntriesFilters'
import type { ReviewEntryTableRow } from '../../../../types/reviewEntryTableRow'
import { formatReviewEntriesFilterPreview } from '../../../../utils/formatReviewEntriesFilterPreview'
import { getAccountOptionsFromRows } from '../../../../utils/getReviewEntriesFilterOptions'
import { MultiSelectFilterBody } from '../../elements/MultiSelectFilterBody'
import { ReviewEntriesFilterChipShell } from '../../ReviewEntriesFilterChipShell'

interface AccountFilterChipProps {
  filters: ReviewEntriesFiltersState
  rows: ReviewEntryTableRow[]
  shouldAutoOpen: boolean
  onAutoOpenHandled: () => void
  onDelete: () => void
  onReset: () => void
  onChange: (values: string[]) => void
}

export const AccountFilterChip = ({
  filters,
  rows,
  shouldAutoOpen,
  onAutoOpenHandled,
  onDelete,
  onReset,
  onChange,
}: AccountFilterChipProps): ReactElement => {
  const { t } = useTranslation()
  const selectedValues = filters.account ?? []
  const options = useMemo(() => getAccountOptionsFromRows(rows), [rows])
  const label = t(FILTER_TYPE_META[ReviewEntriesFilterType.Account].labelKey)

  return (
    <ReviewEntriesFilterChipShell
      isActive={selectedValues.length > 0}
      label={label}
      onAutoOpenHandled={onAutoOpenHandled}
      onDelete={onDelete}
      onReset={onReset}
      shouldAutoOpen={shouldAutoOpen}
      type={ReviewEntriesFilterType.Account}
      valuePreview={formatReviewEntriesFilterPreview(ReviewEntriesFilterType.Account, filters)}
    >
      <MultiSelectFilterBody
        noResultsLabel={t('review_entries.filters.account.no_results')}
        onChange={onChange}
        options={options}
        searchPlaceholder={t('review_entries.filters.account.search_placeholder')}
        selectedValues={selectedValues}
      />
    </ReviewEntriesFilterChipShell>
  )
}
